import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { filter: "url(#filter0_d_1295_22564)" }, [
      _createElementVNode("rect", {
        width: "16",
        height: "16",
        x: "2",
        y: "2",
        fill: "#215f69",
        rx: "8"
      })
    ], -1),
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "6",
      y: "6",
      fill: "#F6F7F8",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F6F7F8",
      d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
      opacity: ".1"
    }, null, -1)
  ]))]))
}
export default { render: render }